import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { EpisodesApi } from '../../../network';
import { EpisodeModel } from '../../../network/rest';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import './style.scss';

function ShowEpisodeDetails() {
    const [data, setData] = useState<EpisodeModel | undefined>();
    const { episodeId } = useParams();

    useEffect(() => {
        const getData = async () => {
            try {
                if (!episodeId) {
                    return;
                }
                const response = await EpisodesApi.getEpisodeApiV1EpisodesEpisodeGet({
                    id: episodeId,
                });
                if (response) {
                    setData(response);
                }
            } catch (e) {
                ApiErrorHandler(e, true);
            }
        };

        getData();
    }, []);

    if (data) {
        return (
            <div className="ShowEpisodeDetails">
                <h1>{data.title}</h1>
                <span className="episode-date">
                    {new Date(data.originalDate).toLocaleDateString()}
                </span>
                <span className="episode-content">
                    {data.fileUrl && (
                        <img src={data.fileUrl as unknown as string} alt={data.title} />
                    )}
                </span>
                <span> {data.html ? parse(data.html) : null}</span>
                <span>{data.content ? parse(data.content) : null}</span>
            </div>
        );
    }
    return null;
}

export default ShowEpisodeDetails;
